import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const isDuplicating = (state: RootState) => state.pages.editor.scene.duplicating;

const isSceneDuplicating = createSelector([isDuplicating], (duplicating) => duplicating);

export default isSceneDuplicating;
